module.exports = __webpack_public_path__ + "img/ford-plaza-gal-1.e78b534e.jpg";